import * as React from "react";
const SvgDailyDoseIcon = (props) => (
  <svg
    width={21}
    height={20}
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    role="img"
    {...props}
  >
    <path
      d="M10.75 5.416A4.583 4.583 0 0 0 8 13.666v3.667a1.833 1.833 0 0 0 1.834 1.833h1.833a1.833 1.833 0 0 0 1.834-1.833v-3.667a4.583 4.583 0 0 0-2.75-8.25Zm1.376 6.958a.917.917 0 0 0-.459.797v4.162H9.834v-4.162a.917.917 0 0 0-.458-.797A2.75 2.75 0 0 1 8 10a2.75 2.75 0 0 1 5.5 0 2.75 2.75 0 0 1-1.375 2.374ZM10.75 4.5a.916.916 0 0 0 .916-.917V1.75a.917.917 0 0 0-1.833 0v1.833a.917.917 0 0 0 .917.917ZM19 9.083h-1.834a.917.917 0 1 
0 0 1.833h1.834a.916.916 0 1 0 0-1.833Zm-14.667 0H2.501a.917.917 0 1 0 0 1.833h1.833a.917.917 0 1 0 0-1.833Zm2.438-4.198-1.32-1.302a.927.927 0 1 0-1.274 1.348l1.32 1.274a.917.917 0 0 0 .67.256.916.916 0 0 0 .66-.284.917.917 0 0 0-.056-1.292Zm10.57-1.256a.917.917 0 0 0-1.293 0l-1.32 1.256a.917.917 0 0 0 0 1.292.917.917 0 0 
0 .66.284.917.917 0 0 0 .633-.256l1.32-1.274a.916.916 0 0 0 0-1.302Z"
      fill="#121212"
      style={{
        mixBlendMode: "multiply",
      }}
    />
  </svg>
);
export default SvgDailyDoseIcon;